(function () {

    var TBODY_VOLTAJE = 'tbodyVoltajeSoplado';
    var TBODY_TIEMPOS = 'tbodyTiemposSoplado';

    function crearCeldasVoltaje(n) {
        var celdas = '';
        for (var p = 1; p <= 8; p++) {
            var nombre = 'voltajeCav' + n + 'P' + p + 'Soplado';
            celdas += '<td>'
                + '<input class="inputPerfil formatoNumero"'
                + ' data-campo="P' + p + '"'
                + ' name="' + nombre + '"'
                + ' id="' + nombre + '"'
                + ' type="text">'
                + '</td>';
        }
        return celdas;
    }

    function crearCeldasTiempos(n) {
        var campos = [
            { campo: 'delay',      prefijo: 'delay' },
            { campo: 'preSoplado', prefijo: 'preSoplado' },
            { campo: 'soplado',    prefijo: 'soplado' }
        ];
        var celdas = '';
        for (var i = 0; i < campos.length; i++) {
            var nombre = campos[i].prefijo + 'Cav' + n + 'Soplado';
            celdas += '<td>'
                + '<input class="inputPerfil formatoNumero"'
                + ' data-campo="' + campos[i].campo + '"'
                + ' name="' + nombre + '"'
                + ' id="' + nombre + '"'
                + ' type="text">'
                + '</td>';
        }
        return celdas;
    }

    function renombrarInputsVoltaje(fila, n) {
        var inputs = fila.querySelectorAll('input[data-campo]');
        for (var i = 0; i < inputs.length; i++) {
            var campo = inputs[i].getAttribute('data-campo');
            var nombre = 'voltajeCav' + n + campo + 'Soplado';
            inputs[i].name = nombre;
            inputs[i].id = nombre;
        }
    }

    function renombrarInputsTiempos(fila, n) {
        var mapaPrefijosCampo = {
            delay:      'delay',
            preSoplado: 'preSoplado',
            soplado:    'soplado'
        };
        var inputs = fila.querySelectorAll('input[data-campo]');
        for (var i = 0; i < inputs.length; i++) {
            var campo = inputs[i].getAttribute('data-campo');
            var prefijo = mapaPrefijosCampo[campo];
            if (!prefijo) continue;
            var nombre = prefijo + 'Cav' + n + 'Soplado';
            inputs[i].name = nombre;
            inputs[i].id = nombre;
        }
    }

    function renumerarAmbas() {
        var tbodyV = document.getElementById(TBODY_VOLTAJE);
        var tbodyT = document.getElementById(TBODY_TIEMPOS);
        if (!tbodyV || !tbodyT) return;

        var filasV = tbodyV.querySelectorAll('tr');
        var filasT = tbodyT.querySelectorAll('tr');

        for (var i = 0; i < filasV.length; i++) {
            var n = i + 1;
            var celdaV = filasV[i].querySelector('.celdaCav');
            if (celdaV) celdaV.textContent = n;
            renombrarInputsVoltaje(filasV[i], n);
        }
        for (var j = 0; j < filasT.length; j++) {
            var m = j + 1;
            var celdaT = filasT[j].querySelector('.celdaCav');
            if (celdaT) celdaT.textContent = m;
            renombrarInputsTiempos(filasT[j], m);
        }
    }

    function crearFilaVoltaje(n) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td class="celdaCav">' + n + '</td>'
            + crearCeldasVoltaje(n)
            + '<td class="celdaEliminarCav">'
            + '<button type="button" class="btnEliminarCavidadPerfil">'
            + '<img src="/public/build/img/icons/papelera.svg" alt="Eliminar" class="artOpePapelera">'
            + '</button>'
            + '</td>';
        return tr;
    }

    function crearFilaTiempos(n) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td class="celdaCav">' + n + '</td>'
            + crearCeldasTiempos(n)
            + '<td class="celdaEliminarCav">'
            + '<button type="button" class="btnEliminarCavidadPerfil">'
            + '<img src="/public/build/img/icons/papelera.svg" alt="Eliminar" class="artOpePapelera">'
            + '</button>'
            + '</td>';
        return tr;
    }

    function agregarCavidad() {
        var tbodyV = document.getElementById(TBODY_VOLTAJE);
        var tbodyT = document.getElementById(TBODY_TIEMPOS);
        if (!tbodyV || !tbodyT) return;

        var n = tbodyV.querySelectorAll('tr').length + 1;
        tbodyV.appendChild(crearFilaVoltaje(n));
        tbodyT.appendChild(crearFilaTiempos(n));
    }

    function eliminarCavidad(btn) {
        var filaActual = btn.closest('tr');
        if (!filaActual) return;

        var tbodyV = document.getElementById(TBODY_VOLTAJE);
        var tbodyT = document.getElementById(TBODY_TIEMPOS);
        if (!tbodyV || !tbodyT) return;

        if (tbodyV.querySelectorAll('tr').length <= 1) return;

        var filasV = tbodyV.querySelectorAll('tr');
        var filasT = tbodyT.querySelectorAll('tr');

        var indice = -1;
        for (var i = 0; i < filasV.length; i++) {
            if (filasV[i] === filaActual) { indice = i; break; }
        }
        if (indice === -1) {
            for (var j = 0; j < filasT.length; j++) {
                if (filasT[j] === filaActual) { indice = j; break; }
            }
        }
        if (indice === -1) return;

        if (filasV[indice]) tbodyV.removeChild(filasV[indice]);
        if (filasT[indice]) tbodyT.removeChild(filasT[indice]);

        renumerarAmbas();
    }

    document.addEventListener('click', function (e) {
        if (e.target.closest('#btnAgregarCavidadPerfiles')) {
            agregarCavidad();
            return;
        }

        var btnEliminar = e.target.closest('.btnEliminarCavidadPerfil');
        if (btnEliminar) {
            eliminarCavidad(btnEliminar);
            return;
        }
    });

})();
